import {Card} from '../../components/ui/Card';
import {Form, FormButtons, FormContent, FormPair} from '../../components/ui/Form';
import {H1, H2} from '../../components/ui/Header';
import {API, graphqlOperation} from 'aws-amplify';
import { createTransaction, createTransactionProducts} from '../../graphql/mutations';
import {useEffect, useState} from 'react';
import {CTAButton} from '../../components/ui/Button';
import {
  CardElement,
  useElements,
  useStripe
} from '@stripe/react-stripe-js';
import Flex from '../../components/ui/Flex';
import styled from 'styled-components';
import {useDispatch, useSelector} from 'react-redux';
import {cartEmptied, selectAllCart} from './cartSlice';
import {selectCurrentUser} from '../user/userSlice';
import {customerByUserID} from '../../graphql/queries';


const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#A16C52",
      color: "#A16C52",
      fontWeight: 500,
      fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": {
        color: "#fce883"
      },
      "::placeholder": {
        color: "#56544d"
      }
    },
    invalid: {
      iconColor: "#A52A2A",
      color: "#A52A2A"
    }
  }
};

const InvoiceLine = styled.div`
  display: flex;
  justify-content: space-between;
  * + * {
    margin-left: 1.5em;
  }
  padding-right: 1em;

  margin-bottom: .5em;
  
`

const Invoice = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
  
`

const InvoiceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export default function Checkout() {
  const user = useSelector(selectCurrentUser)
  const dispatch = useDispatch()
  const cart = useSelector(selectAllCart)
  const [error, setError] = useState(null)
  const [subtotal, setSubtotal] = useState(0)
  const [total, setTotal] = useState(0)
  const [tax, setTax] = useState(0)
  const [taxRate] = useState(0.07)
  const [shipping] = useState(0)
  const [success, setSuccess] = useState(false)

  const stripe = useStripe();
  //const elements = useElements();

  /*
  const history = useHistory()

  const handleSubmit = async (event) => {
    // Block native form submission.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    // Use your card Element with other Stripe.js APIs
    const {error, paymentMethod} = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      console.log('[error]', error);
    } else {
      console.log('[PaymentMethod]', paymentMethod);
    }
  };

   */

  useEffect(() => {
    let newSubtotal = 0.0;
    for(const item of cart) {
      newSubtotal += parseFloat(item.product.price) * parseFloat(item.amount)
    }
    const newTax = (newSubtotal * taxRate)

    setTax(newTax)
    setSubtotal(newSubtotal)
    setTotal(newSubtotal + newTax + shipping)
  }, [cart, taxRate, shipping])

  /*
  useEffect(() => {
    setTotal((subtotal * 1.07).toFixed(2))
  }, [subtotal])

   */

  const handleTransaction = async (e) => {
    e.preventDefault()

    // Create a new Transaction in the database
    let newTransaction
    let userID = 'guest'
    if(user) {
      userID = user.id
    }
    try {

      const customer = await API.graphql(graphqlOperation(`query getCustomer {
        customerByUserID(userID: "6ead0783-ca65-46ef-ac22-64eb4ec30026") {
          items {
            createdAt
            firstname
            id
            lastname
            middlename
            username
            userID
            updatedAt
            phone
            number
          }
        }
      }`))

      console.log(customer)
      const customerData = customer.data.customerByUserID.items[0]
      console.log(customer.id)

      const data = await API.graphql(graphqlOperation(createTransaction,
        {input: {total: total, subtotal: subtotal, shipping: shipping, tax: tax, customerID: customerData.id}}))

      newTransaction = data.data.createTransaction
    } catch(error) {
      console.log(error)
      setError(error)
      return
    }

    for(const product of cart) {
      for (let i = 0; i < product.amount; i++) {
        console.log(product)
        await API.graphql(graphqlOperation(createTransactionProducts,
          {input: {productID: product.product.id, transactionID: newTransaction.id}}))
      }
    }

    dispatch(cartEmptied())
    setSuccess(true)
  }

  if(success) {
    return (
      <Card>
        <H1>Order submitted successfully</H1>
      </Card>
    )
  }

  if(error) {
    return <H1>Error creating transaction: {JSON.stringify(error)}</H1>
  }

  return (
    <Flex>
      <Form onSubmit={handleTransaction}>
        <Card maxWidth='800px'>
          <H1>Disclaimer: This Site is a Demo. No money will be charged and no products will be shipped.</H1>
          <H2>Shipping Information</H2>
          <FormContent>
            <FormPair>
              <label>Address</label>
              <input type='text'/>
            </FormPair>
            <FormPair>
              <label>Address line two (optional)</label>
              <input type='text'/>
            </FormPair>
            <FormPair>
              <label>City</label>
              <input type='text'/>
            </FormPair>
            <FormPair>
              <label>State</label>
              <input type='text'/>
            </FormPair>
            <FormPair>
              <label>Zip Code</label>
              <input type='text'/>
            </FormPair>
          </FormContent>
        </Card>
        <Card>
          <H2>Payment Information</H2>
          <FormContent>
            <CardElement options={CARD_OPTIONS}/>
          </FormContent>
        </Card>
        <Card>
          <H2>Finalized Order</H2>
          <div>
            Shipping
          </div>
          <InvoiceWrapper>
          <Invoice>
            <InvoiceLine >
              <span>Subtotal:</span><span>${subtotal.toFixed(2)}</span>
            </InvoiceLine>
            <InvoiceLine>
              <span>Taxes:</span><span>{' '}${tax.toFixed(2)}</span>
            </InvoiceLine>
            <InvoiceLine>
              <span>Shipping:</span><span>${shipping.toFixed(2)}</span>
            </InvoiceLine>
            <InvoiceLine>
              <span>Total:</span><span>${total.toFixed(2)}</span>
            </InvoiceLine>
          </Invoice>
          </InvoiceWrapper>
          <FormButtons>
            <CTAButton type="submit" disabled={!stripe}>Submit Order</CTAButton>
          </FormButtons>
        </Card>
      </Form>
    </Flex>
  )
}